/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=["transformPerspective","x","y","z","translateX","translateY","translateZ","scale","scaleX","scaleY","rotate","rotateX","rotateY","rotateZ","skew","skewX","skewY"],t=new Set(e);export{e as transformPropOrder,t as transformProps};
//# sourceMappingURL=transform.js.map
